import { DayHours } from '../../types'
import { WeekDays } from '@pogokid/util/datetime'

export interface MonthProps {
  weekDays: WeekDays[]
  weekStartOn: WeekDays
  startHour: DayHours
  endHour: DayHours
}

export const DEFAULT_MONTH_PROPS: MonthProps = {
  weekDays: [0, 1, 2, 3, 4, 5],
  weekStartOn: 6,
  startHour: 9,
  endHour: 17,
}
